import { BrandDefinition } from '../brand.interface';
import { createDefaultBrandTexts, defineBrandConfig } from '../define-brand-config';
import { defineThemeVariables } from '../theme-variable';
import { logo as genericLogo } from './logo-base64';

const buildBrandAssetUrl = (assetPath: string): string =>
  `assets/brands/marca_blanca_generico/${assetPath}`;

const buildDefaultAssets = () => ({
  logoUrl: buildBrandAssetUrl('img/logo.png'),
  footerLogoUrl: buildBrandAssetUrl('svg/isologo-blanco.svg'),
  faviconUrl: buildBrandAssetUrl('img/favicon-32x32.png'),
  favicon16Url: buildBrandAssetUrl('img/favicon-16x16.png'),
  favicon32Url: buildBrandAssetUrl('img/favicon-32x32.png'),
});

export const marcaBlancaGenericoBrand: BrandDefinition = {
  key: 'marca_blanca_generico',
  config: defineBrandConfig({
    displayName: 'TelePagos',
    appName: 'TelePagos',
    siteTitle: 'TelePagos - Plataforma Web',
    copyrightLabel: 'TelePagos',
    assets: buildDefaultAssets(),
    links: {
      website: {
        label: 'telepagos.com.ar',
        url: 'https://www.telepagos.com.ar/',
      },
      apiDocsUrl: 'https://telepagos.com.ar/api/',
      termsUrl: 'https://telepagos.com.ar/#tyc',
      iosAppUrl: 'http://ios.telepagos.com.ar',
      androidAppUrl: 'http://android.telepagos.com.ar',
    },
    export: {
      movimientosFilePrefix: 'movimientos_telepagos',
    },
    texts: {
      ...createDefaultBrandTexts('TelePagos'),
      devicesHelpInstall:
        'Para Agregar un Nuevo Dispositivo tenés que instalar TelePagos en el mismo y loguearte con tus datos.',
      devicesHelpManage:
        'Si querés Eliminar un Dispositivo, tenés que ingresar a la aplicación de TelePagos, luego ingresar en Perfil > Configuración > Dispositivos y eliminar el/los dispositivo/s que quieras.',
      termsHelpPrefix:
        'Para ver los Términos y Condiciones de TelePagos podés ingresar a nuestro sitio web oficial haciendo',
    },
  }),
  logoBase64: genericLogo,
  themeVariables: defineThemeVariables({
    '--primary': '#303030',
    '--primary-op50': '#30303080',
    '--primary-op80': '#303030cc',
    '--primary-dark': '#262626',
    '--primary-darker': '#1f1f1f',
  }),
};
